import * as React from 'react';
import { ButtonCallToAction, ButtonTertiary, MeatballMenu } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';

import { DashboardAdminTranslation } from '../../constants';

import styles from './saved-reports-header.scss';

interface SavedReportsHeaderProps {
  description: string;
  translation: DashboardAdminTranslation;
  onSave: () => void;
  onCancel: () => void;
  onAddReport: () => void;
  onAddReportById: () => void;
}

export const SavedReportsHeader: React.FC<SavedReportsHeaderProps> = ({
  description, translation,
  onSave, onCancel, onAddReport, onAddReportById
}) => (
  <div className={styles.header}>
    <MainGridContainer wide={true}>
      <div className={styles.content}>
        <h1>{description}</h1>
        <ButtonTertiary
          id="dashboard-form-sticky-header-cancel-button"
          onClick={onCancel}>
          {translation.cancel}
        </ButtonTertiary>
        <ButtonCallToAction
          id="dashboard-form-sticky-header-save-button"
          onClick={onSave}
          disabled={false}>
          {translation.save_dashboard_button}
        </ButtonCallToAction>
        <div className={styles.meatballMenu}>
          <MeatballMenu closeAfterClick={true}>
            <li>
              <button
                id="dashboard-form-sticky-header-add-report-button"
                className="dropdown-item"
                onClick={onAddReport}>
                {translation.add_reports}
              </button>
            </li>
            <li>
              <button
                id="dashboard-form-sticky-header-add-report-by-id-button"
                className="dropdown-item"
                onClick={onAddReportById}>
                {translation.add_report_by_id}
              </button>
            </li>
          </MeatballMenu>
        </div>
      </div>
    </MainGridContainer>
  </div>
);
